module.exports = __webpack_public_path__ + "img/2.e93b44cf.jpeg";